import React, { ChangeEvent, useState, useRef, useEffect } from 'react';
import { useAppDispatch } from '../../store';
import {
  attemptLogin,
  setDuringLogin,
  setUserProfile,
} from '../../features/auth/auth';
import { useNavigate } from '../../navigation';
import { Spin } from 'antd';
import { LoadingIcon } from '../components/Spinner';
import { getAuth } from 'firebase/auth';
import { getAnalytics, logEvent } from 'firebase/analytics';
import PillLabel from '../../components/PillLabel';
import PrivacyInfoCard from './components/PrivacyInfoCard';
import * as Sentry from '@sentry/react';
import useQuery from '../../hooks/useQuery';
import { authApi } from '../../api/auth';
import { setStripeId } from '../../features/payment/payment';
import { osName, osVersion } from 'react-device-detect';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import '../../components/PhoneInputStyles.css';
/* typescript-eslint-disable */
declare global {
  interface Window {
    MyNamespace: any;
    recaptchaVerifier;
    confirmationResult;
    recaptchaWidgetId;
    $zopim;
    Square;
  }
}
declare var grecaptcha: any;

window.MyNamespace = window.MyNamespace || {};

const Login: React.FC = props => {
  const [phoneNumber, setPhoneNumber] = useState<string | undefined>('');
  const [showCodeField, setShowCodeField] = useState(false);
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPrivacyPopUp, setShowPrivacyPopUp] = useState(false);
  // var recaptcha;
  const dispatch = useAppDispatch();
  const query = useQuery();
  const analytics = getAnalytics();

  const [path, setPath] = useState<string | null>(null);

  const [isRedirect, setIsRedirect] = useState(false);

  const navigate = useNavigate();

  // var recaptcha;

  useEffect(() => {
    logEvent(analytics, 'login_landed');
  }, []);
  const auth = getAuth();

  useEffect(() => {
    // ZendeskAPI('webWidget', 'show');
  }, []);

  useEffect(() => {
    if (query.get('redirect') != null) {
      console.log(query.get('redirect'));
      setIsRedirect(true);
      setPath(query.get('redirect') ?? '/');
    } else {
      setIsRedirect(false);
    }
  }, [props]);

  async function confirmCode() {
    try {
      const response = await authApi.verifyPhoneVerificationCode({
        phone_number: phoneNumber ?? '',
        code: code,
        os_type: osName + '_' + osVersion,
        channel: 'sms',
      });
      localStorage.setItem('tabletabToken', response.data.token?.access_token);
      localStorage.setItem('tabletabIsLoggedIn', 'true');
      dispatch(setStripeId(response.data.guest?.stripe_id));
      dispatch(setUserProfile(response.data?.guest));
      // ZendeskAPI('webWidget', 'identify', {
      //   name: phoneNumber ?? '',
      // });
      isRedirect ? navigate(path) : navigate('/feed');
    } catch (e) {
      setLoading(false);
      setError('Error: \n' + (e.response?.data?.detail || e.message));
      Sentry.captureException(error);
    }
  }

  async function signInViaPhoneNumber() {
    try {
      const response = await authApi.createPhoneVerificationCode({
        phone_number: phoneNumber ?? '',
        channel: 'sms',
      });
      if (response.data.status == 'pending' || response.data.status == 'sent') {
        setError('');
        setLoading(false);
        setShowCodeField(true);
      }
    } catch (e) {
      setLoading(false);
      setError('Error: \n' + (e.response?.data?.detail || e.message));
      Sentry.captureException(error);
    }
  }

  return (
    <>
      <div className="fixed z-10 inset-0 overflow-y-auto">
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 text-center">
          <div className="fixed inset-0 transition-opacity" aria-hidden="true">
            <div className="absolute inset-0 bg-gray-500 opacity-75" />
          </div>

          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>

          <div
            className="bottom-0 fixed inline-block align-bottom bg-surface rounded-lg px-4 pt-5 pb-4 -mb-20 pb-32 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-full sm:p-6"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div>
              <h2 className="text-3xl leading-9 font-extrabold text-on-surface">
                Log-in to continue
              </h2>
            </div>
            {error !== '' && (
              <div className="rounded-md bg-error-container p-4 my-6">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <svg
                      className="h-5 w-5 text-on-error-container"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h3 className="text-sm leading-5 font-medium text-on-error-container">
                      {error}
                    </h3>
                  </div>
                </div>
              </div>
            )}
            {!showCodeField && (
              <Spin spinning={loading} indicator={LoadingIcon}>
                <form
                  className={'w-full'}
                  onSubmit={async e => {
                    e.preventDefault();
                    setLoading(true);
                    await signInViaPhoneNumber();
                  }}
                >
                  <div>
                    <div className="flex flex-row justify-between items-center">
                      <label
                        htmlFor="tel"
                        className="block text-sm font-medium leading-5 text-on-surface"
                      >
                        Enter Your Phone Number
                      </label>
                      {!showCodeField && (
                        <div className="justify-center content-center items-center">
                          <div
                            className=" rounded"
                            onClick={event => setShowPrivacyPopUp(true)}
                          >
                            <div className="flex flex-col  bg-surface h-full items-center justify-center align-middle">
                              <div className="flex flex-row w-full items-center justify-center">
                                <div className="text-gray-900 flex flex-row items-center text-sm text-left justify-left content-center">
                                  <PillLabel
                                    color="bg-tertiary"
                                    text_color="text-on-tertiary"
                                    label={'Why do we ask this?'}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="mt-1 rounded-md shadow-sm">
                      <PhoneInput
                        id="tel"
                        international
                        defaultCountry="US"
                        placeholder="Enter phone number"
                        value={phoneNumber}
                        onChange={setPhoneNumber}
                        className="appearance-none bg-surface-variant block w-full px-3 py-2 border border-outline-variant rounded-md placeholder-on-surface-variant/60 focus:ring-primary/70 focus:border-primary text-on-surface-variant transition duration-150 ease-in-out text-md sm:leading-5"
                        style={{
                          '--PhoneInputCountryFlag-height': '1em',
                          '--PhoneInputCountrySelectArrow-color':
                            'currentColor',
                        }}
                      />
                    </div>
                  </div>
                  <div className="mt-6 justify-center content-center items-center">
                    <div className="pr-4 min-w-4/5 sm:h-10 max-h-10 sm:flex rounded">
                      <div className="flex flex-col bg-surface h-full items-center justify-center align-middle">
                        <div className="flex flex-row w-full items-center justify-center">
                          <div className="text-on-surface flex flex-row items-center text-sm text-left justify-left content-center">
                            <p>
                              {`You will receive an SMS for verification. Please make sure you have cellular service or WiFi connectivity.`}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-6">
                    <button
                      id={'phone-number-submit'}
                      type="submit"
                      className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-on-primary  sm:text-sm"
                    >
                      Continue
                    </button>
                  </div>
                </form>
              </Spin>
            )}
            {showCodeField && (
              <Spin spinning={loading} indicator={LoadingIcon}>
                <form
                  className={'w-full'}
                  onSubmit={async e => {
                    e.preventDefault();
                    e.stopPropagation();
                    setLoading(true);
                    await confirmCode();
                  }}
                >
                  <div>
                    <label
                      htmlFor="code"
                      className="block text-sm font-medium leading-5 text-gray-on-surface"
                    >
                      Enter Verification Code
                    </label>
                    <div className="mt-1 rounded-md shadow-sm">
                      <input
                        id="code"
                        type="ont-time-code"
                        autoComplete="one-time-code"
                        required
                        value={code}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                          e.preventDefault();
                          const value = e.target.value.replace(/\s/g, '');
                          setCode(value);
                        }}
                        className="appearance-none bg-surface-variant block w-full px-3 py-2 border border-surface-variant rounded-md placeholder-on-surface-variant/60 focus:ring-primary/70 focus:border-primary text-on-surface-variant transition duration-150 ease-in-out text-md sm:leading-5"
                      />
                    </div>
                  </div>
                  <div className="mt-6 justify-center content-center items-center">
                    <div className="pr-4 min-w-4/5 sm:h-10 max-h-10 sm:flex rounded">
                      <div className="flex flex-col bg-surface h-full items-center justify-center align-middle">
                        <div className="flex flex-row w-full items-center justify-center">
                          <div className="text-on-surface flex flex-row items-center text-sm text-left justify-left content-center">
                            <p>
                              {`We have sent a code to +1${phoneNumber}. Press retry if you haven't received it in 60 secs.`}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*<div id={'recaptcha'} ref={ref => (recaptcha = ref)} />*/}
                  <div className="mt-5 sm:mt-6">
                    <button
                      type="submit"
                      className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-on-primary  sm:text-sm"
                    >
                      Confirm
                    </button>
                  </div>
                  <div className="justify-center content-center items-center mt-6">
                    <div
                      className=" w-full  bg-secondary-container  rounded"
                      onClick={async () => {
                        setLoading(false);
                        setShowCodeField(false);
                        // await signInViaPhoneNumber();
                      }}
                    >
                      <div className="flex flex-col p-2 rounded-md h-full items-center justify-center align-middle">
                        <div className="flex flex-row w-full items-center justify-center">
                          <div className="text-on-secondary-container flex flex-row items-center text-sm text-left justify-left content-center">
                            Retry
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </Spin>
            )}

            {showPrivacyPopUp && (
              <PrivacyInfoCard callback={() => setShowPrivacyPopUp(false)} />
            )}
            {
              <div className="justify-center content-center items-center mt-6">
                <div className="  w-full  rounded">
                  <div className="flex flex-col  bg-surface h-full items-center justify-center align-middle">
                    <span className="py-4 text-on-surface  text-xs text-left">
                      By continuing, you agree to our{' '}
                      <a
                        href="https://tabletab.io/terms"
                        target={'_blank'}
                        className=" text-tertiary"
                      >
                        Terms of Service
                      </a>{' '}
                      &{' '}
                      <a
                        href={'https://tabletab.io/privacy'}
                        target={'_blank'}
                        className=" text-tertiary"
                      >
                        Privacy Policy
                      </a>
                      .
                    </span>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
